export default {

	isEmpty (str) {
		if (/\S/.test(str) && str != null) {
			return false;
		}
		return true;
	},

	isEmail (email) {
		let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
	},

	isPwdSafe (password) {
		if (password.length >= 8) {
			return true;
		}
    	return false;	
	},

	s4() {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
   	},

	guid() {
      return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + this.s4() + this.s4();
	},

	dateInFuture(date) {
		let tempo = new Date().toLocaleString().substr(0, 10);
		let now = tempo.split('/');
		let dayNow = Number(now[1]);
		let monthNow = Number(now[0]);
		let yearNow = Number(now[2].substr(0,4));

		let somet = date.split('/');

		// Checking year
		if ( yearNow < Number(somet[2]) ) {
			return false;
		} 
		if ( yearNow > Number(somet[2]) ) {
			return true;
		} 

		// Checking month
		if (  monthNow < Number(somet[1]) ) {
			return false;
		}
		if (  monthNow > Number(somet[1]) ) {
			return true;
		}

		// Checking day
		if ( dayNow < Number(somet[0]) ) {
			return false;
		}

		return true;
	}
}